// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\Api\PSixVesselDimension\ApiPSixVesselDimension.cs
import S, { DataSignal } from 's-js';
import SArray, { SDataArray } from 's-array';
import TZDate from 'lib/TZDate';
import { jsonableObservable } from 'lib/jsonableObservable';
import { PSixVesselResult, PSixVesselResultData, PSixVesselResultOptions } from 'data/models/PSixVesselResult';

// PSixVesselDimensionData is the class that PSixVesselDimension serializes to/from
export interface PSixVesselDimensionData {
    Id : number;
	
    DimensionTypeLookupId : number;
    VesselId : string | null;
    VesselResult : PSixVesselResultData | null;
    VesselResultId : number;
	
    BreadthInFeet : string | null;
    CreatedOnUtc : /* ISO8601 */ string;
    DepthInFeet : string | null;
    DimensionTypeLookupName : string | null;
    Guid : /* GUID */ string;
    LengthInFeet : string | null;
}

// PSixVesselDimensionOptions is the class which may be passed to the PSixVesselDimension constructor to define optional initial data values
export interface PSixVesselDimensionOptions {
    Id : number;
	
    DimensionTypeLookupId? : number;
    VesselId? : string | null;
    VesselResult? : PSixVesselResultOptions | null;
    VesselResultId? : number;
	
    BreadthInFeet? : string | null;
    CreatedOnUtc? : /* ISO8601 */ string;
    DepthInFeet? : string | null;
    DimensionTypeLookupName? : string | null;
    Guid? : /* GUID */ string;
    LengthInFeet? : string | null;
}

export class PSixVesselDimension {
    public Id : DataSignal<number>;
	
    public DimensionTypeLookupId : DataSignal<number>;
    public VesselId : DataSignal<string | null>;
    public VesselResult : DataSignal<PSixVesselResult | null>;
    public VesselResultId : DataSignal<number>;
	
    public BreadthInFeet : DataSignal<string | null>;
    public CreatedOnUtc : DataSignal<TZDate>;
    public DepthInFeet : DataSignal<string | null>;
    public DimensionTypeLookupName : DataSignal<string | null>;
    public Guid : DataSignal<string>;
    public LengthInFeet : DataSignal<string | null>;

    constructor();
    constructor(data : PSixVesselDimensionOptions);
    constructor(data: PSixVesselDimensionOptions | null = null) {
        this.Id = jsonableObservable(S.value<number>(data && data.Id !== undefined ? data.Id : 0));
	    
        this.DimensionTypeLookupId = jsonableObservable(S.value<number>(data && data.DimensionTypeLookupId !== undefined ? data.DimensionTypeLookupId : 0));
        this.VesselId = jsonableObservable(S.value<string | null>(data && data.VesselId !== undefined ? data.VesselId : null));
        this.VesselResult = S.value<PSixVesselResult | null>(null);
        this.VesselResultId = jsonableObservable(S.value<number>(data && data.VesselResultId !== undefined ? data.VesselResultId : 0));
	    
        this.BreadthInFeet = jsonableObservable(S.value<string | null>(data && data.BreadthInFeet !== undefined ? data.BreadthInFeet : null));
        this.CreatedOnUtc = jsonableObservable(S.value<TZDate>(data && data.CreatedOnUtc !== undefined ? new TZDate(data.CreatedOnUtc) : new TZDate(0), TZDate.eq));
        this.DepthInFeet = jsonableObservable(S.value<string | null>(data && data.DepthInFeet !== undefined ? data.DepthInFeet : null));
        this.DimensionTypeLookupName = jsonableObservable(S.value<string | null>(data && data.DimensionTypeLookupName !== undefined ? data.DimensionTypeLookupName : null));
        this.Guid = jsonableObservable(S.value<string>(data && data.Guid !== undefined ? data.Guid : '00000000-0000-0000-0000-000000000000'));
        this.LengthInFeet = jsonableObservable(S.value<string | null>(data && data.LengthInFeet !== undefined ? data.LengthInFeet : null));
    }

    static key(obj : PSixVesselDimension) {
        return obj.Id();
    }
    
    static dataKey(obj : PSixVesselDimensionOptions) {
        return obj.Id;
    }

    static update(obj : PSixVesselDimension, data : PSixVesselDimensionOptions) {
        S.freeze(() => {
            if (data.Id !== undefined) obj.Id(data.Id);
	        
            if (data.DimensionTypeLookupId !== undefined) obj.DimensionTypeLookupId(data.DimensionTypeLookupId);
            if (data.VesselId !== undefined) obj.VesselId(data.VesselId);
            if (data.VesselResultId !== undefined) obj.VesselResultId(data.VesselResultId);
	        
            if (data.BreadthInFeet !== undefined) obj.BreadthInFeet(data.BreadthInFeet);
            if (data.CreatedOnUtc !== undefined) obj.CreatedOnUtc(new TZDate(data.CreatedOnUtc));
            if (data.DepthInFeet !== undefined) obj.DepthInFeet(data.DepthInFeet);
            if (data.DimensionTypeLookupName !== undefined) obj.DimensionTypeLookupName(data.DimensionTypeLookupName);
            if (data.Guid !== undefined) obj.Guid(data.Guid);
            if (data.LengthInFeet !== undefined) obj.LengthInFeet(data.LengthInFeet);
        });
    }
}



// WEBPACK FOOTER //
// ./server/models/PSixVesselDimension.ts